// extracted by mini-css-extract-plugin
export default {"container":"ErrorPage_container__E27VP","headings":"ErrorPage_headings__74oFF"};